"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _elements = require("../../styles/elements");

var ImageBox = (0, _base["default"])("div", {
  target: "erfxpqs0",
  label: "ImageBox"
})("width:", function (_ref) {
  var imgWidth = _ref.imgWidth;
  return imgWidth;
}, ";margin:0 auto;img{width:100%;vertical-align:middle;}");

var HeaderWithImage = function HeaderWithImage(_ref2) {
  var className = _ref2.className,
      img = _ref2.img,
      alt = _ref2.alt,
      title = _ref2.title,
      intro = _ref2.intro,
      imgWidth = _ref2.imgWidth;
  return (0, _jsxRuntime.jsxs)("div", {
    className: className,
    children: [img && (0, _jsxRuntime.jsx)(ImageBox, {
      imgWidth: imgWidth,
      className: "grui mb-12",
      children: (0, _jsxRuntime.jsx)("img", {
        src: img,
        alt: alt
      })
    }), (0, _jsxRuntime.jsx)("h4", {
      className: "grui mb-5",
      css: _elements.heading.styles.h4,
      children: title
    }), (0, _jsxRuntime.jsx)("div", {
      css: [_elements.text.styles.textNormal, _elements.text.styles.textDark, process.env.NODE_ENV === "production" ? "" : ";label:HeaderWithImage;"],
      children: intro
    })]
  });
};

HeaderWithImage.propTypes = {
  className: _propTypes.string,
  img: _propTypes.string,
  imgWidth: _propTypes.string,
  alt: _propTypes.string,
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  intro: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
HeaderWithImage.defaultProps = {
  className: undefined,
  img: undefined,
  imgWidth: '156px',
  alt: undefined,
  title: '',
  intro: ''
};
var _default = HeaderWithImage;
exports["default"] = _default;
//# sourceMappingURL=HeaderWithImage.js.map